import lang from '../lang/language.js';
import format from '../utils/format.js';
import ValidationError from './validation-error.js';

export function getErrors(validations, value) {
  validations = validations || [];
  return validations.reduce((errors, validation) => {
    const error = validation(value);
    if (error) {
      if (error instanceof ValidationError) {
        errors.text.push(error.text());
        errors.errorCode.push(error.key());
      } else if (Array.isArray(error)) {
        errors.text.push(format(lang.getText(error[0]), error.splice(1)));
        errors.errorCode.push(error[0]);
      } else {
        errors.text.push(lang.getText(error));
        errors.errorCode.push(error);
      }
    }
    return errors;
  }, {text: [], errorCode: []});
}
